import type { InputPreset, InputType } from '@publishing/components/forms/input/_types';
import { DEFAULT_VALIDATORS, VARIANT_VALIDATORS } from '@publishing/components/forms/input/_validator';

export type { Validator } from '@publishing/components/forms/input/_validator';

/**
 * input 필드 유효성 검사 단일 진입점.
 *
 * 우선순위: customValidator → presetValidator(회사명·인원 등) → typeValidator(email·tel·date) → text 최소 2자
 * 빈 값 + required → 필수 메시지 / 빈 값 + optional → null(통과)
 */
export function validateField(options: {
  fieldType?: string;
  value: string;
  values?: Record<string, string>;
  required?: boolean;
  label?: string;
  requiredMessage?: string;
  presetKey?: InputPreset;
  customValidator?: (value: string, values: Record<string, string>) => string | null;
}): string | null {
  const { fieldType, value, values = {}, required, label, requiredMessage, presetKey, customValidator } = options;
  const trimmed = value.trim();

  if (required && !trimmed) {
    return requiredMessage ?? (label ? `${label} 값을 입력해 주세요.` : '필수 입력 항목입니다.');
  }

  if (!trimmed) return null;

  if (customValidator) return customValidator(value, values);

  if (presetKey && VARIANT_VALIDATORS[presetKey]) {
    return VARIANT_VALIDATORS[presetKey]!(value, label);
  }

  const typeValidator = DEFAULT_VALIDATORS[fieldType as InputType];
  if (typeValidator) return typeValidator(value, label);

  return null;
}

/**
 * dropdown 필드 유효성 검사.
 * checkbox · radio도 동일하게 사용 가능 (비어있으면 에러)
 */
export function validateDropdown(options: {
  value: string;
  required?: boolean;
  label?: string;
  requiredMessage?: string;
}): string | null {
  const { value, required, label, requiredMessage } = options;
  if (!required || value) return null;
  return requiredMessage ?? (label ? `${label}을(를) 선택해 주세요.` : '필수 선택 항목입니다.');
}
